import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface TabStripProps extends KendoWidgetProps, kendo.ui.TabStripOptions {
    children?: React.ReactNode;
}

export default class TabStrip extends KendoBaseComponent<TabStripProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.TabStrip(domNode as Element, (props as kendo.ui.TabStripOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, dataSource, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            const widget = (this.widgetInstance as kendo.ui.TabStrip);

            if (widget.options.dataSource !== dataSource) {
                widget.setDataSource(dataSource);
            }
        }

        return (
            <div ref={this.elementRef}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/tabstrip/index.tsx